import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import colors, { shadows, borderRadius } from '../theme';

function MorePage() {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);

    useEffect(() => {
        const userData = localStorage.getItem('user');
        if (userData) {
            setUser(JSON.parse(userData));
        }
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('organization');
        navigate('/login');
    };

    const allMenuItems = [
        // Admin only items
        ...(user?.role === 'admin' ? [
            {
                title: 'Billing & Subscription',
                description: 'Manage your plan and billing',
                icon: '💳',
                onClick: () => navigate('/billing'),
                color: colors.landing.coral
            }
        ] : [])
    ];

    return (
        <div style={{ minHeight: '100vh', backgroundColor: colors.gray[50], padding: '2rem' }}>
            <div style={{ maxWidth: '800px', margin: '0 auto' }}>
                {/* Header */}
                <div style={{ marginBottom: '2rem' }}>
                    <h1 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '0.5rem' }}>
                        More
                    </h1>
                    <p style={{ color: colors.gray[600] }}>
                        Settings and additional options
                    </p>
                </div>

                {/* Menu Items */}
                {allMenuItems.length > 0 && (
                    <div style={{ marginBottom: '2rem', display: 'grid', gap: '1rem' }}>
                        {allMenuItems.map((item, index) => (
                            <div
                                key={index}
                                onClick={item.onClick}
                                style={{
                                    backgroundColor: colors.white,
                                    padding: '1.5rem',
                                    borderRadius: borderRadius.lg,
                                    boxShadow: shadows.sm,
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    border: `2px solid transparent`,
                                }}
                                onMouseOver={(e) => {
                                    e.currentTarget.style.borderColor = item.color || colors.blue[500];
                                    e.currentTarget.style.boxShadow = shadows.md;
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                }}
                                onMouseOut={(e) => {
                                    e.currentTarget.style.borderColor = 'transparent';
                                    e.currentTarget.style.boxShadow = shadows.sm;
                                    e.currentTarget.style.transform = 'translateY(0)';
                                }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                    <div style={{ fontSize: '2rem' }}>{item.icon}</div>
                                    <div style={{ flex: 1 }}>
                                        <h3 style={{
                                            fontSize: '1.125rem',
                                            fontWeight: '600',
                                            marginBottom: '0.25rem',
                                            color: colors.gray[900]
                                        }}>
                                            {item.title}
                                        </h3>
                                        <p style={{ fontSize: '0.875rem', color: colors.gray[600], margin: 0 }}>
                                            {item.description}
                                        </p>
                                    </div>
                                    <div style={{ fontSize: '1.5rem', color: colors.gray[400] }}>→</div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {/* Coming Soon Section */}
                {allMenuItems.length === 0 && (
                    <div style={{ marginBottom: '2rem', textAlign: 'center', padding: '4rem 2rem' }}>
                        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🚀</div>
                        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '0.5rem', color: colors.gray[700] }}>
                            More features coming soon!
                        </h2>
                        <p style={{ color: colors.gray[600] }}>
                            We're working on exciting new features for you.
                        </p>
                    </div>
                )}

                {/* Account Info */}
                {user && (
                    <div style={{
                        backgroundColor: colors.white,
                        padding: '1.5rem',
                        borderRadius: borderRadius.lg,
                        boxShadow: shadows.sm,
                        marginBottom: '2rem'
                    }}>
                        <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '1rem', color: colors.gray[700] }}>
                            Account Information
                        </h2>
                        <div style={{ display: 'grid', gap: '0.75rem' }}>
                            <div>
                                <p style={{ fontSize: '0.875rem', color: colors.gray[600], marginBottom: '0.25rem' }}>Name</p>
                                <p style={{ fontSize: '1rem', fontWeight: '500' }}>{user.name}</p>
                            </div>
                            <div>
                                <p style={{ fontSize: '0.875rem', color: colors.gray[600], marginBottom: '0.25rem' }}>Email</p>
                                <p style={{ fontSize: '1rem', fontWeight: '500' }}>{user.email}</p>
                            </div>
                            <div>
                                <p style={{ fontSize: '0.875rem', color: colors.gray[600], marginBottom: '0.25rem' }}>Role</p>
                                <p style={{ fontSize: '1rem', fontWeight: '500', textTransform: 'capitalize' }}>{user.role}</p>
                            </div>
                        </div>
                    </div>
                )}

                {/* Logout Button */}
                <div style={{ textAlign: 'center' }}>
                    <button
                        onClick={handleLogout}
                        style={{
                            padding: '0.75rem 2rem',
                            backgroundColor: colors.white,
                            color: colors.red[600],
                            border: `2px solid ${colors.red[600]}`,
                            borderRadius: borderRadius.md,
                            fontSize: '1rem',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseOver={(e) => {
                            e.currentTarget.style.backgroundColor = colors.red[600];
                            e.currentTarget.style.color = colors.white;
                        }}
                        onMouseOut={(e) => {
                            e.currentTarget.style.backgroundColor = colors.white;
                            e.currentTarget.style.color = colors.red[600];
                        }}
                    >
                        Logout
                    </button>
                </div>
            </div>
        </div>
    );
}

export default MorePage;
